export default "__VITE_ASSET__jxmvnhfpiC2w3Y112DEmhw__"